<template>
    <div class="cart_container" :class="{'cart_open': !buttonCartIsVisible(), 'cart_close': buttonCartIsVisible()}">
        <div class="overlay" v-if="cartVisible" @click="toggleCartVisibility()">
            <DefaultButton :text="getString('continuar_comprando')" outlined="true" :layoutGom="true"></DefaultButton>
        </div>
        <div class="minimize_cart" v-if="!buttonCartIsVisible() && cart && cart.length !== 0" @click="minimizeCart()">
            <img :src="minus_white">
        </div>
        <ShowCart v-if="!isCartEmpty && buttonCartIsVisible()" @toggleCartVisibility="toggleCartVisibility()"></ShowCart>
        <div class="empty_cart" v-if="cart.length === 0 && false">
            <img :src="shopping_cart_white">
            <span v-text="getString('carrinho_vazio')"></span>
        </div>
        <transition name="cart-itens-container-landscape">
            <div class="cart-itens-container" v-if="cartVisible">
                <div class="cart_item_container" :class="{'androidMode': isAndroidMode()}" v-for="(product, key) in cart" :key="key">
                    <QuantityControl
                        v-if="!product.productScale"
                        :quantity="product.quantity"
                        :disabledMinus="product.insertedByEan13"
                        :disabledPlus="product.insertedByEan13"
                        @circleBtnRemove="decreaseQtty(key)"
                        @circleBtnAdd="increaseQtty(key)">
                    </QuantityControl>
                    <div v-else class="prod_quantity">
                            <span v-text="product.quantity + ' Kg'"></span>
                    </div>
                    <div class="product_item">
                        <span class="prod_name" :class="{'unavaiable': getLimits(product.productCode)}" >{{ getProductLanguage(product, 'productName') }}</span>
                        <span v-if="product.observations && product.observations.length === 0 && product.productCombo && product.productCombo.length === 0 && product.productDescription" class="prod_description">
                            {{ resizeDescription(getProductLanguage(product, 'productDescription')) }}
                        </span>
                        <div v-else class="observations">
                            <!-- Exibe as observações no carrinho -->
                            <span v-for="(observation, key) in product.observations" :key="key">
                                {{ getProductLanguage(observation, 'obsName') }}
                            </span>
                            <!-- Exibe no carrinho os itens do combo que foram escolhidos -->
                            <span v-for="(comboItem, key2) in product.productCombo" :key="key2" :class="{'unavaiable': getLimits(comboItem.subItemCode)}">
                                {{ getProductLanguage(comboItem, 'subItemName') }}
                            </span>
                        </div>
                    </div>
                    <span class="item_price" style="margin:auto">{{ calculateItemPrice(product) }}</span>
                    <div class="circle_buttons">
                        <CircleButton v-if="!product.productScale" class="edit_button" :disabled="product.insertedByEan13 || product.isertedByBarCode" :icon="edit_white" :big="iconesGrandes" @circleBtnClick="edit(product, key)"></CircleButton>
                        <CircleButton :icon="delete_white" :big="iconesGrandes" @circleBtnClick="deleteProduct(key)"></CircleButton>
                    </div>
                </div>
            </div>
        </transition>

        <div>
            <div class="total_price">
                <span class="price_text">{{ getString('total_caps') }}</span>
                <span class="price_number">{{ calculateTotalPrice() }}</span>
            </div>
            <div class="footer_buttons">
                <DefaultButton :text="getString('cancelar')" outlined="true" @defaultBtnClick="clearCart"></DefaultButton>
                <DefaultButton :text="wait ? getString('aguarde') : getString('confirmar_pedido')" :disabled="cart.length === 0 || wait"  @defaultBtnClick="navigateToCheckout"></DefaultButton>
            </div>
        </div>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
import CircleButton from '@/components/CircleButton'
import QuantityControl from '@/components/QuantityControl'
import LocaleController from '@/assets/controllers/LocaleController'
import CartController from '@/assets/controllers/CartController'
import eventModule from '@/assets/libs/eventModule'
import ShowCart from '../components/ShowCart.vue'

export default {
    name: 'Cart',
    components: {
        DefaultButton,
        CircleButton,
        QuantityControl,
        ShowCart
    },
    data () {
        return {
            cartVisible: false,
            showButtonCart: false,
            isCartEmpty: CartController.getCart().length === 0,
            cart: CartController.getCart(),
            shopping_cart_white: require('../../static/icons/shopping_cart_white.svg'),
            edit_white: require('../../static/icons/edit_white.svg'),
            delete_white: require('../../static/icons/delete_white.svg'),
            minus_white: require('../../static/icons/minus_white.svg'),
            iconesGrandes: Util.getLocalConfigs('iconesGrandes'),
            wait: false,
            unavailableProducts: CartController.getUnavailableProducts()
        }
    },
    created () {
        eventModule.$on('openCart', this.toggleCartVisibility)
        eventModule.$on('toggleWaitStatus', this.toggleWaitStatus)
    },
    beforeDestroy () {
        eventModule.$off('openCart', this.toggleCartVisibility)
        eventModule.$off('toggleWaitStatus', this.toggleWaitStatus)
    },
    methods: {
        minimizeCart: function () {
            eventModule.$emit('refreshProductsCounter')
            this.cartVisible = false
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        calculateItemPrice: function (product) {
            return CartController.calculateItemPrice(product)
        },
        calculateTotalPrice: function () {
            return CartController.calculateTotalPrice(false, false)
        },
        decreaseQtty: function (key) {
            CartController.decreaseQtty(key, this)
            this.isCartEmpty = CartController.getCart().length === 0
            this.$forceUpdate()
        },
        increaseQtty: function (key) {
            CartController.increaseQtty(key)
            this.$forceUpdate()
        },
        navigateToCheckout: function () {
            CartController.navigateToCheckout(this.$router)
        },
        deleteProduct: function (key) {
            CartController.deleteProduct(key, this)
            this.isCartEmpty = CartController.getCart().length === 0
            this.$forceUpdate()
        },
        clearCart: function () {
            if (CartController.isCartEmpty()) {
                this.$router.push('/')
            } else {
                CartController.clearCart(this, '/')
            }
        },
        edit: function (product, key) {
            this.$router.push({
                name: 'ProductItem',
                params: {product, key}
            })
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        resizeDescription: function (productDescription) {
            if (!productDescription) {
                return ''
            }
            const DESCRIPTION_MAX_CHARACTERS = 50
            let description = '' + productDescription
            if (description.length > DESCRIPTION_MAX_CHARACTERS) {
                description = description.substring(0, DESCRIPTION_MAX_CHARACTERS) + '...'
            }
            return description
        },
        buttonCartIsVisible: function () {
            return !this.cartVisible
        },
        toggleCartVisibility: function (status = null) {
            this.isCartEmpty = CartController.getCart().length === 0
            if (status) {
                this.cartVisible = status
                setTimeout(() => {
                    let itemCart = document.querySelectorAll('.cart_item_container')
                    if (itemCart && itemCart.length > 0) {
                        itemCart = itemCart[itemCart.length - 1]
                        itemCart.scrollIntoView({behavior: 'smooth'})
                    }
                }, 300)
            } else {
                this.cartVisible = !this.cartVisible
            }
        },
        toggleWaitStatus: function (status) {
            this.wait = status
        },
        getLimits: function (productCode) {
            if (this.unavailableProducts && this.unavailableProducts[productCode]) {
                return this.unavailableProducts[productCode].quantity > this.unavailableProducts[productCode].quantityAvailable
            }
            return false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .cart_container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 2rem;
        // min-height: 475px;
        background: @cart-color;
        color: var(--cart-font-color);
        .cart-itens-container {
            max-height: 405px;
            overflow: auto;
            overflow-x: hidden;
        }
        .overlay {
            display: none;
        }
        &.androidMode {
            font-size: 1.8rem;
            min-height: 400px;
        }

        .minimize_cart {
            width: 100px;
            height: 50px;
            background-color: @primary-color;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            margin-top: -50px;
            right: 0;
            img {
                width: 48px;
                height: 48px;
            }
        }
        &.cart_open {
            max-height: 560px;
            transition: max-height 0.4s ease-in;
        }
        &.cart_close {
            max-height: 190px;
            transition: max-height 0.3s ease-out;
        }
    }

    .empty_cart {
        padding-top: 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
            width: 200px;
            height: 150px;
        }
        span {
            padding-top: 15px;
            font-size: 3rem;
            color: @white;
        }
    }

    .cart_item_container {
        display: grid;
        position: relative;
        padding: 30px;
        grid-template-columns: 200px 50% auto auto;

        .edit_button {
            margin-right: 1.5rem;
        }
        &.androidMode {
            grid-template-columns: 140px auto auto auto;
        }
        .prod_quantity {
            font-weight: bold;
            text-align: center;
        }
    }

    .item_quantity {
        font-weight: bold;
        margin: auto;
        display: block;
        text-align: center;
    }

    .prod_name {
        font-weight: bold;
        &.unavaiable {
            color: red;
        }
    }

    .prod_description {
        font-size: 1.5rem;
    }

    .item_price {
        font-size: 1.5rem;
    }

    .circle_buttons {
        display: flex;
        // margin: auto;
        justify-content: end;
        align-items: center;
    }

    .total_price {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        padding-right: 3rem;
        padding-top: 1rem;
        padding-bottom: 1rem;
        margin-right: 15px;
    }

    .price_text {
        font-size: 1.5rem;
        padding-right: 0.5rem;
    }

    .price_number {
        font-size: 2.5rem;
        font-weight: bold;
    }

    .product_item {
        padding-left: 30px;
        span {
            display: block;
        }
        .observations {
            font-size: 1.5rem;
            display: flex;
            flex-wrap: wrap;
            span {
                display: inline-block;
                margin: 0 5px 5px 0;
                border: 1px solid @primary-dark;
                background-color: @primary-dark;
                color: @white;
                font-weight: bold;
                padding: 5px 8px;
                border-radius: 10px;
                &.unavaiable {
                    background-color: red;
                }
            }
        }
    }

    .footer_buttons {
        display: flex;
        justify-content: space-around;
        // padding-bottom: 2rem;
        padding-bottom: 10px;
        .button-default{
            width: calc(50% - 30px);
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        .cart_container {
            font-size: 15px !important;
            // min-height: 270px !important;

            .minimize_cart {
                width: 50px;
                height: 25px;
                margin-top: -25px;
                img {
                    width: 24px;
                    height: 24px;
                }
            }
            &.cart_open {
                max-height: 400px !important;
                transition: max-height 0.4s ease-in !important;
            }
            &.cart_close {
                max-height: 100px;
                transition: max-height 0.3s ease-out;
            }
        }
        .empty_cart {
            padding-top: 20px;
            img {
                width: 50px;
                height: 50px;
            }
            span {
                padding-top: 1rem;
                font-size: 25px;
            }
        }
        .cart_item_container {
            padding: 5px;
            grid-template-columns: 105px 47% auto auto !important;
            .edit_button {
                margin-right: 0.5rem;
            }
        }
        .prod_description {
            font-size: 15px !important;
        }
        .item_price {
            font-size: 15px !important;
        }
        .total_price {
            padding-right: 0;
            padding-top: 10px;
            padding-bottom: 10px;
            margin-right: 20px;
        }
        .price_text {
            font-size: 15px;
        }
        .price_number {
            font-size: 20px;
        }
        .product_item {
            padding: 0 5px 0 10px;
            .observations {
                font-size: 12px;
                span {
                    margin: 0 1px 1px 0;
                    padding: 3px 5px;
                }
            }
        }
        .footer_buttons {
            padding-bottom: 5px;
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .cart_container {
            font-size: 1.4rem;
            // min-height: 400px;
            .cart-itens-container {
                max-height: 380px;
            }
            &.cart_open {
                max-height: 400px;
                transition: max-height 0.4s ease-in;
            }
            &.cart_close {
                max-height: 155px;
                transition: max-height 0.3s ease-out;
            }
            .minimize_cart {
                width: 50px;
                height: 25px;
                margin-top: -25px;
                img {
                    width: 24px;
                    height: 24px;
                }
            }
        }

        .empty_cart {
            padding-top: 20px;
            img {
                width: 150px;
                height: 150px;
            }
            span {
                padding-top: 1rem;
                font-size: 2.5rem;
            }
        }

        .cart_item_container {
            padding:15px;
            grid-template-columns: 135px 50% auto auto;

            .edit_button {
                margin-right: 0.5rem;
            }
        }

        .prod_description {
            font-size: 1.2rem;
        }

        .item_price {
            padding: 0 5px;
            font-size: 1.4rem;
        }

        .total_price {
            padding-right: 0rem;
            margin-right: 20px;
        }

        .price_text {
            font-size: 1.2rem;
            padding-right: 0.5rem;
        }

        .price_number {
            font-size: 1.7rem;
        }

        .product_item {
            padding-left: 10px;
            padding-right: 10px;
            .observations {
                font-size: 18px;
            }
        }
    }
    /* @media (orientation: landscape) {
        .cart_container {
            font-size: 1.3rem;
            .cart-itens-container {
                max-height: 350px;
            }
            &.cart_open {
                max-height: 350px;
                transition: max-height 0.4s ease-in;
            }
            &.cart_close {
                max-height: 140px;
                transition: max-height 0.3s ease-out;
            }
            .minimize_cart {
                width: 50px;
                height: 25px;
                margin-top: -25px;
                img {
                    width: 24px;
                    height: 24px;
                }
            }
        }

        .empty_cart {
            padding-top: 20px;
            img {
                width: 150px;
                height: 150px;
            }
            span {
                padding-top: 1rem;
                font-size: 2.5rem;
            }
        }

        .cart_item_container {
            padding:15px;
            grid-template-columns: 200px 50% auto auto;

            .edit_button {
                margin-right: 0.5rem;
            }
        }

        .prod_description {
            font-size: 1.2rem;
        }

        .item_price {
            font-size: 1.2rem;
        }

        .total_price {
            padding-right: 0rem;
            margin-right: 20px;
        }

        .price_text {
            font-size: 1.5rem;
            padding-right: 0.5rem;
        }

        .price_number {
            font-size: 1.5rem;
        }

        .product_item {
            padding-left: 40px;
            .observations {
                font-size: 20px;
            }
        }
    } */

    @media (orientation: landscape) {
    .cart_container {
        z-index: 3;

        .cart-itens-container {
            z-index: 3;
            // height: 200px;
            position: absolute;
            top: 91px;
            bottom: 81px;
            right: 0;
            // height: 70vh;
            // height: 70vh;
            max-height: unset;
            width: 55vw;
            background-color: @cart-color;
            padding: 10px 0;
        }

        .overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 110px;
            background-color: rgba(0, 0, 0, 0.6);
            z-index: 2;
            display: block;

            .button-default {
                z-index: 10;
                position: absolute;
                top: 50%;
                left: 15%;
            }
        }

        .minimize_cart {
            display: none;
            z-index: 10;
            width: 50px;
            height: 25px;
            margin-top: -25px;

            img {
                width: 24px;
                height: 24px;
            }
        }
        >div:last-child {
            z-index: 3;
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
        }
    }

    .cart_item_container {
        z-index: 3;
        width: 100%;
        padding: 10px;
        grid-template-columns: 140px 30% 130px auto;
        border-bottom: solid 1px rgba(0, 0, 0, 0.1);

        .circle_buttons {
            max-width: 100px;
        }
    }

    .item_price {
        padding: 5px 10px;
        font-size: 24px;
    }

    .total_price {
        padding-right: 30px;
        margin-right: 0;
        padding-top: 0;
        padding-bottom: 0;
        order: 2;
    }

    .footer_buttons {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 50%;
        padding-bottom: 0;

        .button-default {
            max-width: 250px;
        }
    }

    .price_text {
        font-size: 20px;
        padding-right: 10px;
        padding-bottom: 1px;
    }

    .price_number {
        font-size: 25px;
    }

    .product_item {
        padding-left: 5px;

        .prod_name {
            font-size: 20px;
        }

        .prod_description {
            font-size: 16px;
        }

        .observations {
            font-size: 16px;

            .sub-item {
                span {
                    font-size: 16px;
                }
            }
        }
    }

    .cart-itens-container-landscape-enter-active,
    .cart-itens-container-landscape-leave-active {
        transition: transform 0.35s ease;
    }

    .cart-itens-container-landscape-enter {
        transform: translateX(100%);
    }

    .cart-itens-container-landscape-enter-to {
        transform: translateX(0);
    }

    .cart-itens-container-landscape-leave {
        transform: translateX(0);
    }

    .cart-itens-container-landscape-leave-to {
        transform: translateX(100%);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Cart.vue